module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/layout/layout-top-panel-3-1d5e565566a6bd5bdb07ad70715843ba.svg";